import { render, staticRenderFns } from "./CatchInvoice.vue?vue&type=template&id=2b0fb632&scoped=true"
var script = {}
import style0 from "./CatchInvoice.vue?vue&type=style&index=0&id=2b0fb632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0fb632",
  null
  
)

export default component.exports